import { SearchTab } from "owa-search-types/lib/types/SearchTab";
import { getActiveScopeTab, getActiveSearchTab, isTabbedSearchEnabled } from "owa-tabbed-search";
import type SearchScenarioId from "owa-search-store/lib/store/schema/SearchScenarioId";
import type { Refiner } from "owa-search-types";
import getSearchRefinersState from "./getSearchRefinersState";

export default function getAppliedRefiners(scenarioId: SearchScenarioId): Refiner[] {
    let currentTab: SearchTab | undefined = SearchTab.Mail;
    if (isTabbedSearchEnabled(false /*isFromQfScopeTabs*/)) {
        const activeTab = getActiveSearchTab();
        // Fall back to the All tab only when both the search tab and scope tab
        // are undefined, which indicates search was initiated before a search
        // session was started (e.g. category search or find related conversations).
        currentTab = activeTab ?? (getActiveScopeTab() === undefined ? SearchTab.All : undefined);
    }
    if (!currentTab) {
        return [];
    }
    // Return only those applied refiners which pertain to the current tab
    return (getSearchRefinersState(scenarioId).appliedRefiners ?? []).filter(refiner => refiner.applicableTabs.indexOf(currentTab as SearchTab) !== -1);
}
